(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push(() => {
  if (window.tgpcCartDrawer) return;
  window.tgpcCartDrawer = true;

  const drawer = () => document.querySelector('[data-cart-drawer]');
  const content = () => document.querySelector('[data-cart-drawer-content]');

  const openDrawer = () => {
    const dialog = drawer();
    if (dialog && !dialog.open) dialog.showModal();
  };

  /* Re-render the drawer; a token discards stale markup so responses can't
     land out of order. Mutations carry the fresh HTML in their own response
     (bundled section rendering) — refresh() only covers events without it. */
  let renderSeq = 0;
  const replaceContent = (box, fresh) => {
    if (!fresh) return;

    const active = document.activeElement;
    const restoreFocus = box.contains(active);
    const activeControl = restoreFocus
      ? active.closest?.('[data-cart-drawer-remove], [data-cart-drawer-qty], [data-step]')
      : null;
    let activeKey = activeControl?.dataset.key;
    let activeAction = activeControl?.matches('[data-cart-drawer-remove]') ? 'remove' : 'quantity';
    let activeStep;

    if (activeControl?.matches('[data-step]')) {
      activeAction = 'step';
      activeStep = activeControl.dataset.step;
      activeKey = activeControl.parentElement.querySelector('[data-cart-drawer-qty]')?.dataset.key;
    }

    box.innerHTML = fresh.innerHTML;

    if (restoreFocus) {
      const findByKey = (selector) =>
        Array.from(box.querySelectorAll(selector)).find((element) => element.dataset.key === activeKey);
      let target;
      if (activeAction === 'remove') target = findByKey('[data-cart-drawer-remove]');
      if (activeAction === 'quantity') target = findByKey('[data-cart-drawer-qty]');
      if (activeAction === 'step') {
        target = findByKey('[data-cart-drawer-qty]')?.parentElement.querySelector(`[data-step="${activeStep}"]`);
      }
      (target || box.querySelector('[data-dialog-close], a, button, input'))?.focus();
    }
  };

  const renderFrom = (html) => {
    const box = content();
    if (!box) return;
    renderSeq += 1;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    replaceContent(box, fresh);
    box.classList.remove('is-busy');
  };

  const refresh = async () => {
    const box = content();
    if (!box) return;
    const seq = ++renderSeq;
    box.classList.add('is-busy');
    try {
      const fresh = await window.tgpc.fetchSection(`${window.tgpc.routes.cart}?section_id=cart-drawer`, '[data-cart-drawer-content]');
      if (fresh && seq === renderSeq) replaceContent(box, fresh);
    } catch {
      /* keep the old markup; the next cart:updated rerenders */
    } finally {
      if (seq === renderSeq) box.classList.remove('is-busy');
    }
  };

  /* Line changes queue one behind another so rapid +/- clicks can't
     land out of order; each response re-renders the drawer directly. */
  let queue = Promise.resolve();
  const send = (key, quantity) => {
    content()?.classList.add('is-busy');
    queue = queue
      .then(() =>
        fetch(`${window.tgpc.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' }),
        })
      )
      .then((response) => response.json())
      .then((cart) => {
        if (cart.status) {
          window.tgpcToast(cart.message || window.tgpc.strings.cartError);
          refresh();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(() => refresh());
  };

  document.addEventListener('cart:updated', (event) => {
    const dialog = drawer();
    const html = event.detail && event.detail.sections && event.detail.sections['cart-drawer'];
    if (html) renderFrom(html);
    else refresh();
    if (dialog && !dialog.open && !document.querySelector('.cart-page')) dialog.showModal();
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-button]');
    if (opener && drawer() && !document.querySelector('.cart-page')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const remove = event.target.closest('[data-cart-drawer-remove]');
    if (remove) send(remove.dataset.key, 0);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-drawer-qty]');
    if (!input) return;
    const quantity = Math.max(0, Math.floor(Number(input.value)) || 0);
    input.value = quantity;
    send(input.dataset.key, quantity);
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
  scope.querySelectorAll('[data-cart-form]').forEach((form) => {
    /* typed or stepped ([data-step] in theme.js), any qty change debounce-submits */
    let debounce;
    form.addEventListener('change', (event) => {
      if (!event.target.closest('[data-cart-qty]')) return;
      clearTimeout(debounce);
      debounce = setTimeout(() => form.submit(), 500);
    });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
    /* Filters, sort and pagination re-render in place via the Section
       Rendering API (same pattern as the cart drawer) — no page reloads.
       Events are delegated on the layout wrapper, which survives swaps. */
    const root = scope.matches?.('[data-collection-results]')
      ? scope
      : scope.querySelector?.('[data-collection-results]');
    if (!root || root.dataset.ajaxBound) return;
    root.dataset.ajaxBound = 'true';

    const sectionId = root.dataset.sectionId;
    let renderSeq = 0;

    const groupStates = () =>
      Array.from(root.querySelectorAll('.collection-filters__group'), (group) => group.hasAttribute('open'));

    const restoreGroupStates = (states) => {
      root.querySelectorAll('.collection-filters__group').forEach((group, index) => {
        if (states[index] === undefined) return;
        group.toggleAttribute('open', states[index]);
      });
    };

    const render = async (url, push = true) => {
      const seq = ++renderSeq;
      const states = groupStates();
      root.classList.add('is-busy');
      try {
        const target = new URL(url, window.location.origin);
        const fetchUrl = new URL(target);
        fetchUrl.searchParams.set('section_id', sectionId);
        const fresh = await window.tgpc.fetchSection(fetchUrl.toString(), '[data-collection-results]');
        if (!fresh || seq !== renderSeq) return;
        root.innerHTML = fresh.innerHTML;
        restoreGroupStates(states);
        if (push) window.history.pushState({ tgpcCollection: true }, '', target.toString());
        window.tgpc.runInits?.(root);
      } catch (error) {
        window.location.assign(url); /* graceful fallback: plain navigation */
      } finally {
        if (seq === renderSeq) root.classList.remove('is-busy');
      }
    };

    root.addEventListener('change', (event) => {
      const form = event.target.closest('[data-tag-filter-form]');
      if (form && event.target.matches('[data-tag-filter-input]')) {
        const paramName = form.dataset.filterParam;
        const params = new URLSearchParams(window.location.search);
        const selectedValues = Array.from(form.querySelectorAll('[data-tag-filter-input]:checked'), (input) => input.value);
        const nextUrl = new URL(form.action, window.location.origin);

        params.delete('page');
        params.delete(paramName);

        if (selectedValues.length > 0) {
          params.set(paramName, selectedValues.join(','));
        }

        nextUrl.search = params.toString();
        render(nextUrl.toString());
        return;
      }

      if (event.target.matches('[data-sort-form] select[name="sort_by"]')) {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', event.target.value);
        params.delete('page');
        const nextUrl = new URL(window.location.pathname, window.location.origin);
        nextUrl.search = params.toString();
        render(nextUrl.toString());
      }
    });

    root.addEventListener('click', (event) => {
      const link = event.target.closest(
        '.pagination a, .collection-filters__clear, .collection-filters__options a.chip, .collection-empty__btn'
      );
      if (!link) return;
      event.preventDefault();
      const fromPagination = Boolean(link.closest('.pagination'));
      render(link.href).then(() => {
        if (fromPagination) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    window.addEventListener('popstate', () => {
      if (document.body.contains(root)) render(window.location.href, false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!window.tgpcFooterMenuDisclosure) {
    const media = window.matchMedia('(max-width: 749px)');
    const sync = (menu) => {
      const summary = menu.querySelector('summary');
      menu.open = !media.matches;
      if (media.matches) summary?.removeAttribute('tabindex');
      else {
        if (document.activeElement === summary) summary.blur();
        summary?.setAttribute('tabindex', '-1');
      }
    };

    const bind = (menu) => {
      if (menu.dataset.footerMenuBound) return;
      menu.dataset.footerMenuBound = '1';
      menu.querySelector('summary')?.addEventListener('click', (event) => {
        if (!media.matches) event.preventDefault();
      });
    };

    window.tgpcFooterMenuDisclosure = { sync, bind };
    media.addEventListener('change', () => {
      document.querySelectorAll('[data-footer-menu]').forEach(sync);
    });

    (window.tgpcInit = window.tgpcInit || []).push((scope) => {
      scope.querySelectorAll('[data-footer-menu]').forEach((menu) => {
        bind(menu);
        sync(menu);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
    /* --- takeover mega menu --- */
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    scope.querySelectorAll('.has-mega').forEach((item) => {
      if (item.dataset.megaBound) return;
      item.dataset.megaBound = '1';
      const trigger = item.querySelector('[data-mega-trigger]');
      let timer;

      const close = (el) => {
        (el || item).classList.remove('is-open');
        (el || item).querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        clearTimeout(timer);
        document.querySelectorAll('.has-mega.is-open').forEach((o) => o !== item && close(o));
        item.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
      };

      if (coarse) {
        trigger?.addEventListener('click', (e) => {
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            open();
          }
          /* second tap follows the link */
        });
      } else {
        item.addEventListener('mouseenter', () => {
          clearTimeout(timer);
          timer = setTimeout(open, 150);
        });
        item.addEventListener('mouseleave', () => {
          clearTimeout(timer);
          timer = setTimeout(() => close(), 120);
        });
        trigger?.addEventListener('focus', open);
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) close();
        });
      }
    });

    if (!window.tgpcHeaderGlobalBound) {
      window.tgpcHeaderGlobalBound = true;

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          document.querySelectorAll('.has-mega.is-open').forEach((o) => {
            o.classList.remove('is-open');
            o.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
          });
        }
      });

      const desktopMenu = window.matchMedia('(min-width: 990px)');
      const closeMobileMenu = () => {
        const dialog = document.querySelector('#MenuDrawer');
        if (desktopMenu.matches && dialog?.open) dialog.close();
      };
      if (desktopMenu.addEventListener) desktopMenu.addEventListener('change', closeMobileMenu);
      else desktopMenu.addListener(closeMobileMenu);
      closeMobileMenu();
    }

    const searchOverlay = scope.querySelector('[data-search]');
    const searchInput = searchOverlay?.querySelector('input[type="search"]');
    const searchResults = searchOverlay?.querySelector('[data-search-results]');

    if (searchOverlay && !searchOverlay.dataset.searchBound) {
      searchOverlay.dataset.searchBound = '1';

      if (location.hash === '#search' && !searchOverlay.open) searchOverlay.showModal();

      if (searchInput && searchResults) {
        let debounceTimer;
        let controller;
        let requestSeq = 0;

        const clearResults = () => {
          searchResults.hidden = true;
          searchResults.innerHTML = '';
          searchOverlay.classList.remove('has-results');
        };

        const cancelSearch = () => {
          clearTimeout(debounceTimer);
          controller?.abort();
          controller = null;
          requestSeq += 1;
        };

        const runSearch = async (query) => {
          const seq = requestSeq;
          const requestController = new AbortController();
          controller = requestController;
          const url = `${searchResults.dataset.predictiveUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;

          try {
            const inner = await window.tgpc.fetchSection(url, '.predictive', { signal: requestController.signal });
            if (!inner || seq !== requestSeq || searchInput.value.trim() !== query) return;
            searchResults.innerHTML = inner.innerHTML;
            searchResults.hidden = false;
            searchOverlay.classList.add('has-results');
          } catch (error) {
            if (seq === requestSeq && error.name !== 'AbortError') clearResults();
          } finally {
            if (controller === requestController) controller = null;
          }
        };

        searchInput.addEventListener('input', () => {
          cancelSearch();
          const query = searchInput.value.trim();
          if (query.length < 2) {
            clearResults();
            return;
          }
          debounceTimer = setTimeout(() => runSearch(query), 220);
        });

        searchOverlay.addEventListener('close', () => {
          cancelSearch();
          searchInput.value = '';
          clearResults();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hire-range"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hire-range')) {
  customElements.define('hire-range', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-hire-filters]')?.removeAttribute('hidden');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-hire-filter]');
        if (button) this.filter(button.dataset.hireFilter);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-hire-card]');
        if (card) this.filter('');
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    filter(category) {
      let count = 0;
      this.querySelectorAll('[data-hire-card]').forEach(card => {
        card.hidden = Boolean(category && card.dataset.category !== category);
        if (!card.hidden) count++;
      });
      this.querySelectorAll('[data-hire-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hireFilter === category)));
      const status = this.querySelector('[data-hire-count]');
      if (status) status.textContent = `${count} ${status.dataset.countLabel}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
    scope.querySelectorAll('[data-klaviyo-form]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', trigger.dataset.klaviyoForm]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursery-game"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadGame = (section) => {
      if (window.TGPCNurseryGameLoading) return;
      const source = section.dataset.nurseryGameScript;
      if (!source) return;
      window.TGPCNurseryGameLoading = true;
      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.addEventListener('error', () => {
        window.TGPCNurseryGameLoading = false;
      });
      document.head.appendChild(script);
    };

    const observeGames = (root = document) => {
      root.querySelectorAll('[data-nursery-game-section]').forEach((section) => {
        if (!('IntersectionObserver' in window)) {
          loadGame(section);
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            loadGame(section);
          },
          { rootMargin: '200px' },
        );
        observer.observe(section);
      });
    };

    observeGames();
    document.addEventListener('shopify:section:load', (event) => {
      observeGames(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  /* admin page content pasted from word processors ends in &nbsp;-filled
     paragraphs/headings; their stacked margins open big blank gaps (worst on
     the shipping page before the helpful-pages card). CSS :empty can't match
     whitespace-only nodes, so prune them here. */
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
    scope.querySelectorAll('.page-section__content.rte :is(p, h1, h2, h3, h4, h5, h6)').forEach((el) => {
      if (el.querySelector('img, svg, iframe, video, embed, object, audio, table, input, button')) return;
      if (!el.textContent.replace(/[\s\u00A0]+/g, '')) el.remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
  scope.querySelectorAll('[data-ptabs]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        let nextIndex;
        if (e.key === 'Home') nextIndex = 0;
        else if (e.key === 'End') nextIndex = tabs.length - 1;
        else if (e.key === 'ArrowRight') nextIndex = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') nextIndex = (i - 1 + tabs.length) % tabs.length;
        else return;
        e.preventDefault();
        select(tabs[nextIndex], true);
      });
    });

    if (tabs.length) select(tabs[0]);
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
  scope.querySelectorAll('.pdp-wrap').forEach((root) => {
    const dataEl = root.parentElement.querySelector('[data-variant-data]');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const form = root.querySelector('.pdp__form');
    if (!form) return;

    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-button]');
    const priceEl = root.querySelector('[data-price] .price__amount');
    const compareEl = root.querySelector('[data-price] .price__compare');
    const compareAmountEl = compareEl && compareEl.querySelector('.price__compare-amount');
    const availabilityEl = root.querySelector('[data-availability]');
    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

    const selectedOptions = () =>
      Array.from(root.querySelectorAll('.pdp__option')).map(
        (fieldset) => fieldset.querySelector('input:checked')?.value
      );

    const syncChipStyles = () => {
      root.querySelectorAll('.pdp__chips .chip').forEach((chip) => {
        chip.classList.toggle('on', chip.querySelector('input').checked);
      });
    };

    const selectThumb = (thumb) => {
      if (!mainImage || !thumb) return;
      if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
      mainImage.src = thumb.dataset.full;
      mainImage.alt = thumb.dataset.alt || '';
      thumbs.forEach((item) => item.classList.toggle('on', item === thumb));
    };

    const onVariantChange = () => {
      const options = selectedOptions();
      const variant = variants.find((v) =>
        options.every((value, index) => !value || v.options[index] === value)
      );

      syncChipStyles();

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = root.dataset.unavailableText;
        }
        if (availabilityEl) availabilityEl.textContent = root.dataset.unavailableText;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.style.display = '';
          if (compareAmountEl) compareAmountEl.textContent = variant.compare_at_price_formatted;
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (availabilityEl) availabilityEl.textContent = variant.available ? '' : root.dataset.soldOutText;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? root.dataset.addText : root.dataset.soldOutText;
      }

      const variantThumb = thumbs.find((thumb) => thumb.dataset.mediaId === String(variant.media_id));
      selectThumb(variantThumb);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    root.querySelectorAll('[data-option-value]').forEach((input) => {
      input.addEventListener('change', onVariantChange);
    });
    syncChipStyles();

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => selectThumb(thumb));
    });

    const giftInput = form.querySelector('[data-gift-input]');
    const giftCount = form.querySelector('[data-gift-count]');
    if (giftInput && giftCount) {
      const update = () => {
        giftCount.textContent = `${giftInput.value.length} / ${giftInput.maxLength}`;
      };
      giftInput.addEventListener('input', update);
      update();
    }
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (window.tgpcInit = window.tgpcInit || []).push((scope) => {
  scope.querySelectorAll('[data-related-products]').forEach((container) => {
    const url = container.dataset.url;
    if (!url) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();

        window.tgpc
          .fetchSection(url, '[data-related-products]')
          .then((fresh) => {
            if (fresh && fresh.innerHTML.trim()) container.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(container);
  });
  });

  } catch(e) { console.error(e); }
})();
})();
